//Same 4 languages as translate/languages/ — the rest of app.Questions' language keys are a
//one-off bulk auto-translation artifact (~39 rows each, checked live 2026-09-14), not real
//distinct survey content worth a benchmark catalog entry. Shared between BankQuestionManageModal
//(grouping known/scanned texts by language) and CreateBankQuestionModal (picking which language a
//manually-created question is in).
export const BANK_QUESTION_LANGUAGES = ["fr", "en", "de", "es"]
export const BANK_QUESTION_LANGUAGE_LABELS: Record<string, string> = {
  fr: "Français",
  en: "English",
  de: "Deutsch",
  es: "Español"
}
export const BANK_QUESTION_LANGUAGE_FLAGS: Record<string, string> = { fr: "🇫🇷", en: "🇬🇧", de: "🇩🇪", es: "🇪🇸" }
